import { type SmsChatMessage } from '@/models/smsChat';

// sms-api hands the send to a worker, so the chat row for a sent message appears a
// moment after the mutation resolves. Until then the message is shown from memory.
export const PENDING_SMS_TIMEOUT_MS = 60_000;

export interface PendingSmsMessage {
  readonly contactId: string;
  readonly messageId: string;
  readonly body: string;
  readonly sentAt: string;
}

interface GetUnsettledPendingMessagesInput {
  readonly pending: readonly PendingSmsMessage[];
  readonly messages: readonly SmsChatMessage[];
  readonly now: number;
}

// A pending message is settled by the chat row carrying the same message id, which is
// the id sendSmsHandoff returned for it. A row that never arrives is dropped on timeout
// so a stalled worker cannot leave a bubble on screen indefinitely.
export const getUnsettledPendingMessages = ({
  pending,
  messages,
  now,
}: GetUnsettledPendingMessagesInput): readonly PendingSmsMessage[] => {
  const arrivedMessageIds = new Set(
    messages.flatMap((message) => (message.messageId == null ? [] : [message.messageId])),
  );

  return pending.filter((entry) => {
    if (now - Date.parse(entry.sentAt) > PENDING_SMS_TIMEOUT_MS) {
      return false;
    }

    return !arrivedMessageIds.has(entry.messageId);
  });
};
